import React, { useEffect, useState } from "react";
import fishImg from "../../assets/images/service/s5.png";
import FishDescription from "./FishDescription";
import FishEx1 from "./FishEx";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
import { getCookie } from "../../util/Cookie";
import { TokenName, handleModalController } from "../../util/Common";
import LoginModal from "../../component/modal/LoginModal";
const FishService = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoginModal, setLoginModal] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModalController({
      windowWidth,
      setShowModal,
      setShowMobileModal,
      setLoginModal,
    });
  };
  return (
    <>
      <div
        className="mt-5 row sercice-details-content pb--80 align-items-center"
        id="fishDetection"
      >
        <div className="col-lg-6 col-12">
          <div className="thumb">
            <img className="w-100" src={fishImg} alt="Service Images" />
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">어종검출 API</h4>
            <p>
              이미지에서 해양생물을 검출하고 검출한 객체에 대한 위치정보를
              감지할 수 있습니다. JSON 포멧 기반의 입출력을 지원합니다.
            </p>

            <ul className="liststyle mt-4">
              <li>
                243종의 한국연근해 다양한 어종에 대하여 학습한 인공지능 모델
              </li>
              <li>
                객체를 검증할 뿐만 아니라 학명, 서식지, 행태등 다양한 정보를
                추가적으로 제공
              </li>
              <li>수신, 낚시 등 관련 업종에 대한 서비스 활용 가능</li>
            </ul>
          </div>
          <div
            style={{
              cursor: `pointer`,
            }}
            className="slide-btn mt-2"
          >
            <a
              onClick={() => handleClick()}
              className="rn-button-style--2 btn-primary-color"
            >
              신청하기
            </a>
          </div>
        </div>
      </div>
      <FishDescription></FishDescription>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <div className="row sercice-details-content pb--80 align-items-center">
        <FishEx1></FishEx1>
      </div>
      <LoginModal isOpen={isLoginModal} onClose={() => setLoginModal(false)} />
    </>
  );
};
export default FishService;
